export const FORMAT = {
  API_DDMMYYYY: 'DD.MM.YYYY',
  API_DDMMYYYY_HHMM: 'DD.MM.YYYY hh:mm',
  YYYYMMDD: 'YYYY-MM-DD',
  YYYYMMDD_HHMM: 'YYYY-MM-DD hh:mm',
}
